const C = {
  name: "Retail",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 4C10.8923 4 10 4.89228 10 6H8C8 3.78772 9.78772 2 12 2C14.2123 2 16 3.78772 16 6C16 7.86687 14.727 9.4314 13 9.87445V11.4117L20.4556 15.5558C20.4556 15.5558 20.4557 15.5559 20.4556 15.5558C21.4005 16.0808 22 17.084 22 18.18V19C22 20.6523 20.6523 22 19 22H5C3.34772 22 2 20.6523 2 19V18.18C2 17.0928 2.58195 16.0837 3.5468 15.5545L11 11.4117V8H12C13.1077 8 14 7.10772 14 6C14 4.89228 13.1077 4 12 4ZM12 13.1441L4.50982 17.3074C4.1967 17.4786 4 17.8085 4 18.18V19C4 19.5477 4.45228 20 5 20H19C19.5477 20 20 19.5477 20 19V18.18C20 17.816 19.7994 17.4792 19.4844 17.3042L12 13.1441Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as Retail
};
